import { BuilderBoot } from './boot/BuilderBoot';
import { BuilderRouter } from './routes/BuilderRouter';

/**
 * Builder app root (M3.1). The silent-refresh auth gate wraps the router, which loads the real draft
 * into the Zustand store and renders the store-fed 3-panel shell:
 *
 *   <BuilderBoot>  → silent refresh from the HttpOnly cookie (or bounce to dashboard login)
 *     <BuilderRouter>  → the one editor route (?template&handle&locale); triggers store.load()
 *       <BuilderShell> → 3-panel editor rendering the loaded document via BuilderCanvas/MemoSection
 */
export function App() {
  return (
    <BuilderBoot>
      <BuilderRouter />
    </BuilderBoot>
  );
}
